import axios from "axios";

import store from "@/store.js";

export default {
  id: 6,
  adminOnly: false,
  type: "purchases",
  title: "Compras",
  deleteEntriesAllowed: false,
  actions: {
    get: "getPurchases",
    post: "postPurchase",
    patch: "patchPurchase",
    delete: "deletePurchase",
  },
  headers: [
    {
      title: "Fecha",
      field: {
        name: "updatedDate",
        type: "date",
      },
    },
    {
      title: "Nombre",
      field: {
        name: "nombre",
        type: null,
      },
    },
    {
      title: "Apellidos",
      field: {
        name: "apellidos",
        type: null,
      },
    },
    {
      title: "Email",
      field: {
        name: "email",
        type: null,
      },
    },
    {
      title: "Nombre Alumno",
      field: {
        name: "nombre_alumno",
        type: null,
      },
    },
    {
      title: "Apellidos Alumno",
      field: {
        name: "apellidos_alumno",
        type: null,
      },
    },
    {
      title: "ID Alumno",
      field: {
        name: "ID_Alumno",
        type: "select",
        multiple: false,
        async: true,
        function: ({ searchQuery, callback }) => {
          if (searchQuery.length < 3) {
            return;
          }

          axios
            .get("server/index.php", {
              params: {
                action: "searchStudents",
                colegio: store.state.user.colegio,
                searchQuery,
              },
            })
            .then((response) => {
              const options = response.data.map((student) => ({
                id: student.num,
                label: student.ID_Alumno,
              }));
              callback(null, options);
            });
        },
        editable: true,
      },
    },
    {
      title: "Forma pago",
      field: {
        name: "forma_de_pago",
        type: null,
      },
    },
  ],
  options: [],
  filters: [
    {
      title: "Nombre",
      name: "nombre",
      type: "select",
      fromExtras: true,
      options: "name_distinct",
      optionName: "nombre",
      async: true,
    },
    {
      title: "Apellidos",
      name: "apellidos",
      type: "select",
      fromExtras: true,
      options: "lastname_distinct",
      optionName: "apellidos",
      async: true,
    },
    {
      title: "Email",
      name: "email",
      type: "select",
      fromExtras: true,
      options: "email_distinct",
      optionName: "email",
      async: true,
    },
    {
      title: "Nombre Alumno",
      name: "nombre_alumno",
      type: "select",
      fromExtras: true,
      options: "student_name_distinct",
      optionName: "nombre_alumno",
      async: true,
    },
    {
      title: "Apellidos Alumno",
      name: "apellidos_alumno",
      type: "select",
      fromExtras: true,
      options: "student_lastname_distinct",
      optionName: "apellidos_alumno",
      async: true,
    },
    {
      title: "ID Alumno",
      name: "ID_Alumno",
      type: "select",
      fromExtras: true,
      options: "student_id_distinct",
      optionName: "ID_Alumno",
      async: true,
    },
    {
      title: "Fecha desde",
      name: "date_from",
      type: "date",
    },
    {
      title: "Fecha hasta",
      name: "date_to",
      type: "date",
    },
    {
      title: "Tipo de pago",
      name: "forma_de_pago",
      type: "select",
      options: [
        {
          id: "1",
          label: "Transferencia",
        },
        {
          id: "2",
          label: "Tarjeta",
        },
        {
          id: "4",
          label: "Financiado",
        },
      ],
    },
  ],
};
